import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../hooks/auth/AuthContext";
import { Form, Button, Card, Container, Alert } from "react-bootstrap";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  /* =========================
     Google Login
  ========================= */
  const handleGoogleLogin = () => {
    window.location.href = "/api/auth/login";
  };

  /* =========================
     Local Login
  ========================= */
  const handleLocalLogin = async (e) => {
    e.preventDefault();

    setMessage("");

    try {
      const response = await axios.post(
        "/api/auth/login",
        {
          email,
          password,
        },
        {
          withCredentials: true,
        }
      );

      login(response.data.user);
      navigate("/");
    } catch (error) {
      setMessage(
        error.response?.data?.error ||
          "Invalid email or password."
      );
    }
  };

  /* =========================
     Cancel
  ========================= */
  const handleCancel = () => {
    navigate("/");
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">

      <Card className="shadow-lg p-4" style={{ width: "430px" }}>
        <Card.Body>

          <h2 className="text-center mb-4">
            STEMX365 Login
          </h2>

          {message && (
            <Alert variant="danger">
              {message}
            </Alert>
          )}

          {/* Local Login */}

          <Form onSubmit={handleLocalLogin}>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                autoComplete="username"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter your password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Button
              type="submit"
              variant="primary"
              className="w-100"
            >
              Login
            </Button>

          </Form>

          <div className="text-center mt-3">
            <Link to="/forgot-password">
              Forgot Password?
            </Link>
          </div>

          <hr className="my-4" />

          <Button
            variant="danger"
            className="w-100"
            onClick={handleGoogleLogin}
          >
            Sign in with Google
          </Button>

          <Button
            variant="secondary"
            className="w-100 mt-3"
            onClick={handleCancel}
          >
            Cancel
          </Button>

          <div className="text-center mt-4">
            Don't have an account?{" "}
            <Link to="/rect/register">
              Register
            </Link>
          </div>

        </Card.Body>
      </Card>

    </Container>
  );
}